let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bmzPB")).then(() => parcelRequire('iBpSq'));